import React from 'react';
import { FiStar, FiEdit2 } from 'react-icons/fi';
import { GoTrash } from 'react-icons/go';
import { FaRegBuilding } from "react-icons/fa";
import { strings } from "../../../strings/strings";

const ReviewTable = ({ reviews, onEdit, onDelete, onToggleStatus }) => {
  return (
    <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-200 dark:border-slate-800 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm text-gray-500 dark:text-gray-400">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-slate-800 dark:text-gray-300">
            <tr>
              <th scope="col" className="px-6 py-3">{strings.COMPANY_LOGO}</th>
              <th scope="col" className="px-6 py-3">{strings.REVIEWER_NAME}</th>
              <th scope="col" className="px-6 py-3">{strings.COMPANY_NAME_LABEL}</th>
              <th scope="col" className="px-6 py-3">{strings.DESIGNATION}</th>
              <th scope="col" className="px-6 py-3">{strings.RATING}</th>
              <th scope="col" className="px-6 py-3">{strings.REVIEW_CONTENT}</th>
              <th scope="col" className="px-6 py-3">{strings.STATUS}</th>
              <th scope="col" className="px-6 py-3">{strings.DISPLAY_ORDER || 'Order'}</th>
              <th scope="col" className="px-6 py-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {reviews.map((review) => (
              <tr key={review.id} className="bg-white border-b dark:bg-slate-900 dark:border-slate-800 hover:bg-gray-50 dark:hover:bg-slate-800/50">
                <td className="px-6 py-4">
                  <div className="h-10 w-10 bg-gray-100 dark:bg-slate-800 rounded flex items-center justify-center overflow-hidden">
                    {review.companyLogo ? (
                      <img src={review.companyLogo} alt="Company" className="w-full h-full object-contain p-1" />
                    ) : (
                      <FaRegBuilding className="w-5 h-5 text-gray-400" />
                    )}
                  </div>
                </td>
                <td className="px-6 py-4 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                  {review.name}
                </td>
                <td className="px-6 py-4">
                  {review.companyName || '-'}
                </td>
                <td className="px-6 py-4">
                  {review.designation || '-'}
                </td>
                <td className="px-6 py-4">
                  <div className="flex text-yellow-400 text-xs">
                    {[...Array(5)].map((_, i) => (
                      <FiStar key={i} className={i < review.rating ? "fill-current" : "text-gray-300 dark:text-slate-600"} />
                    ))}
                  </div>
                </td>
                <td className="px-6 py-4">
                  <div className="truncate max-w-xs">
                    {review.reviewNotes}
                  </div>
                </td>
                <td className="px-6 py-4">
                  <button 
                    onClick={() => onToggleStatus(review)}
                    className="hover:opacity-80 transition-opacity focus:outline-none"
                    title="Click to toggle status"
                  >
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      review.isActive 
                        ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' 
                        : 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400'
                    }`}>
                      {review.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </button>
                </td>
                <td className="px-6 py-4">
                  {review.displayOrder || '-'}
                </td>
                <td className="px-6 py-4 text-right">
                  <div className="flex justify-end gap-2">
                    <button onClick={() => onEdit(review)} className="p-2 text-gray-400 hover:text-primary hover:bg-primary/10 rounded-lg transition-colors">
                      <FiEdit2 className="w-4 h-4" />
                    </button>
                    <button onClick={() => onDelete(review)} className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10 rounded-lg transition-colors">
                      <GoTrash className="w-4 h-4" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReviewTable;
